import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useState } from 'react';
var CJK_BLOCKS = ["[\u3300-\u33FF]", // CJK_COMPATIBILITY
"[\uFE30-\uFE4F]", // CJK_COMPATIBILITY_FORMS
"[\uF900-\uFAFF]", // CJK_COMPATIBILITY_IDEOGRAPHS
"\uD87E[\uDC00-\uDE1E]", // CJK_COMPATIBILITY_IDEOGRAPHS_COMPLEMENT
"[\u2E80-\u2EFF]", // CJK_RADICALS_SUPPLEMENT
"[\u3000-\u303F]", // CJK_SYMBOLS_AND_PUNCTUATION
"[\u4E00-\u9FFF]", // CJK_UNIFIED_IDEOGRAPHS
"[\u3400-\u4DBF]", // CJK_UNIFIED_IDEOGRAPHS_EXTENSION_A
"[\uD840-\uD868][\uDC00-\uDFFF]|\uD869[\uDC00-\uDEDE]", // CJK_UNIFIED_IDEOGRAPHS_EXTENSION_B
"[\u2FF0-\u2FFF]", // IDEOGRAPHIC_DESCRIPTION_CHARACTERS
"[\u2F00-\u2FDF]", // KANGXI_RADICALS
// Japanese
"[\u3040-\u309F]", // HIRAGANA
"[\u30A0-\u30FF]", // KATAKANA
// Korean
"[\u3130-\u318F]", // HANGUL_COMPATIBILITY_JAMO
"[\u1100-\u11FF]", // HANGUL_JAMO
"[\uAC00-\uD7AF]" // HANGUL_SYLLABLES
];
var CJK_REGEX = new RegExp(CJK_BLOCKS.join('|'));
export var containsCJKCharacter = function containsCJKCharacter(input) {
  return !!input && CJK_REGEX.test(input);
};
export var TokenType;

(function (TokenType) {
  TokenType["Words"] = "words";
  TokenType["Characters"] = "characters";
})(TokenType || (TokenType = {}));

var getWordsCount = function getWordsCount(text) {
  return text.split(/\s+/).filter(function (x) {
    return x.trim().length;
  }).length;
};

var getCharactersCount = function getCharactersCount(text) {
  return text.length;
};

export var getRecommendedLengthCount = function getRecommendedLengthCount(tokenType, enteredText) {
  switch (tokenType) {
    case TokenType.Words:
      return getWordsCount(enteredText);

    case TokenType.Characters:
      return getCharactersCount(enteredText);

    default:
      return 0;
  }
};

var defaultGetRecommendedText = function defaultGetRecommendedText(tokenType) {
  return function (_ref) {
    var tokenCount = _ref.tokenCount,
        recommendedLength = _ref.recommendedLength;
    return "".concat(tokenCount, " ").concat(tokenType, " entered. ").concat(recommendedLength, " or fewer are recommended");
  };
};

export var useRecommendedLength = function useRecommendedLength(_ref2) {
  var value = _ref2.value,
      autoDetectTokenType = _ref2.autoDetectTokenType,
      tokenType = _ref2.tokenType,
      recommendedLength = _ref2.recommendedLength,
      getExceededText = _ref2.getExceededText,
      _ref2$getRecommendedT = _ref2.getRecommendedText,
      getRecommendedText = _ref2$getRecommendedT === void 0 ? defaultGetRecommendedText(tokenType) : _ref2$getRecommendedT,
      getErrorText = _ref2.getErrorText;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      footerText = _useState4[0],
      setFooterText = _useState4[1];

  var _useState5 = useState(tokenType),
      _useState6 = _slicedToArray(_useState5, 2),
      autoDetectedTokenType = _useState6[0],
      setTokenType = _useState6[1];

  var getFooterText = useCallback(function (tokenCount) {
    var isError = !!getErrorText;
    var isWarning = !!getExceededText && tokenCount > recommendedLength;

    if (isError) {
      return !!getErrorText ? getErrorText() : '';
    }

    if (isWarning) {
      return !!getExceededText ? getExceededText({
        tokenCount: tokenCount,
        recommendedLength: recommendedLength
      }) : '';
    }

    return getRecommendedText({
      tokenCount: tokenCount,
      recommendedLength: recommendedLength
    });
  }, [recommendedLength, getExceededText, getRecommendedText, getErrorText]);
  var getTokenCount = useCallback(function (enteredText) {
    return getRecommendedLengthCount(autoDetectTokenType ? autoDetectedTokenType : tokenType, enteredText);
  }, [tokenType, autoDetectedTokenType, autoDetectTokenType]);
  useEffect(function () {
    var tokenCount = getTokenCount(value);
    setTokenType(containsCJKCharacter(value) ? TokenType.Characters : tokenType);
    setCount(tokenCount);
    setFooterText(getFooterText(tokenCount));
  }, [value, recommendedLength, getFooterText, getTokenCount, tokenType]);
  var progress = count / recommendedLength;
  return {
    footerText: footerText,
    warning: count > recommendedLength,
    error: !!getErrorText,
    progress: Number.isNaN(progress) ? 0 : progress,
    count: count,
    autoDetectedTokenType: autoDetectedTokenType
  };
};